import { observer } from 'mobx-react-lite';

import { AppPage } from 'app/common/app-page/features/app-page/app-page';
import {
  NotificationsProvider,
  useNotifyFactory,
} from 'app/common/notifications/features/notifications';
import { PageContent } from 'app/ui';

import { DetailsProfile } from '../features';

export const DetailsProfilePage = observer(() => {
  const notify = useNotifyFactory();

  return (
    <NotificationsProvider value={notify}>
      <AppPage perm="PERM_TERMINAL_PROFILE_READ">
        <PageContent>
          <DetailsProfile />
        </PageContent>
      </AppPage>
    </NotificationsProvider>
  );
});
